<template>
    <div class="history-places results-surface">
        <div class="history-places__scroll results-surface__scroll">
            <table class="history-places__table">
                <thead>
                    <tr>
                        <th class="history-places__season-col">Сезон</th>
                        <th
                            v-for="column in matrix.columns"
                            :key="column"
                            class="history-places__place-col"
                        >
                            <PlaceBadge :place="column" />
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="row in matrix.rows" :key="row.season_id">
                        <th class="history-places__season-col">
                            {{ row.season_name }}
                        </th>
                        <td
                            v-for="column in matrix.columns"
                            :key="`${row.season_id}-${column}`"
                            class="history-places__cell"
                        >
                            <div
                                v-if="(row.cells[column] || []).length"
                                class="history-places__teams"
                            >
                                <component
                                    v-for="team in row.cells[column]"
                                    :key="team.id"
                                    :is="teamPublicPath(team) ? 'a' : 'div'"
                                    :href="teamPublicPath(team) || undefined"
                                    class="history-places__team"
                                    :class="{ 'history-places__team--link': !!teamPublicPath(team) }"
                                >
                                    <div v-if="team.logo_path" class="team-logo-small">
                                        <img :src="team.logo_path" :alt="team.name" />
                                    </div>
                                    <div v-else class="team-logo-small placeholder">
                                        {{ team.name?.charAt(0) }}
                                    </div>
                                    <span v-if="team.name" class="team-name-small">{{ team.name }}</span>
                                    <span v-if="team.city" class="history-places__city">{{ team.city }}</span>
                                </component>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script setup>
import PlaceBadge from '@/components/player/PlaceBadge.vue';
import { teamPublicPath } from '@/utils/teamUrl';

defineProps({
    matrix: {
        type: Object,
        required: true,
        default: () => ({
            columns: [],
            rows: [],
        }),
    },
});
</script>
